import { render, staticRenderFns } from "./LocalFileUploaderV2.vue?vue&type=template&id=3892246b&scoped=true"
import script from "./LocalFileUploaderV2.vue?vue&type=script&lang=js"
export * from "./LocalFileUploaderV2.vue?vue&type=script&lang=js"
import style0 from "./LocalFileUploaderV2.vue?vue&type=style&index=0&id=3892246b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892246b",
  null
  
)

export default component.exports